let sizeChartBlock = document.querySelector('.best-fit-size-chart');
let sizeVariantLabel = document.querySelector('.swatches .swatch-label:has(input[name="Size"])');

const updateSizeChartPosition = () => {
  const interval = setInterval(() => {
    sizeChartBlock = document.querySelector('.best-fit-size-chart');
    sizeVariantLabel = document.querySelector('.swatches .swatch-label:has(input[name="Size"])');
    console.log(sizeChartBlock)
    console.log(sizeVariantLabel)
    
    if (sizeChartBlock && sizeVariantLabel) {
      // Move size chart button inside size variant label
      sizeVariantLabel.appendChild(sizeChartBlock);

      // Ensure click event moves it back when clicked
      window.removeEventListener('click', handleSizeChartClick);
      window.addEventListener('click', handleSizeChartClick);

      clearInterval(interval);
    }
  }, 500);
};

// Function to handle click and re-append the button
const handleSizeChartClick = () => {
  sizeVariantLabel = document.querySelector('.swatches .swatch-label:has(input[name="Size"])');

  if (sizeChartBlock && sizeVariantLabel) {
    console.log('Size chart button clicked! Moving it again.');
    sizeVariantLabel.appendChild(sizeChartBlock);
  }
};

window.addEventListener("DOMContentLoaded", updateSizeChartPosition);